export default __webpack_public_path__ + "static/media/react.81db2bfe.svg";